import { Cartao } from './cartao';
import { KycValidations } from './kyc';

export class Collaborator {
    public toDelete: boolean;
    public selected: boolean;
    public esporadico = false;
    public cartao: Cartao;
    public hasApp: any;
    public situationID: number;
    public situation: string;
    public accounts: Cartao[];
    public blocked: boolean;
    public reason: string;
    public collaboratorType: string;
    public collaboratorTypeId: number;
    public collaboratorCardId: string;
    public collaboratorCardDefinitiveBlock: boolean;
    public collaboratorCardTemporaryBlock: boolean;
    public CollaboratorCardActive: boolean;
    public CollaboratorCardLastDigits: boolean;
    public accountDisabled: boolean = false;
    public conductor: boolean = false;
    public cardholder: boolean = false;
    public cardholderGuid: string;
    public cardholderCardId: string;
    public cardholderCardLastDigits: string;
    public suspended: boolean;
    public phoneNumber: string;
    public kycValidations: KycValidations[];

    constructor(
        public collaboratorID: number,
        public name: string,
        public document: string,
        public register: string,
        public costCenter: string,
        public unit: string,
        public departament: string,
        public hasCard: boolean,
        public personGuid: string,
        public qrCode: string
    ) { }
}

export class CollaboratorFiltered{
    public id: number;
    public name: string;
}

export class CollaboratorAccounts{
    public personGuid: string;
    public accountsGuid: string[];
}
